import { useState } from "react";
// models
import { PostulacionBepsModel, initialValuesPostulacionBepsModel } from "../models/Beps/postulaciones.model";
//  api services
import apiParticipantes from "../api/Participantes/api-participantes";
// download files
import fileDownload from "js-file-download";
import { notification } from "antd";
import apiConvocatorias from "../api/Convocatorias/api-convocatorias";
import {
  filtrosPostulacionModel,
  initialFiltrosPostulacionModel,
} from "../models/PostulacionesModel/postulacion.model";
import DocumentosService from "../api/Documentos/api-documentos";
import { ObjNotificaciones } from "../config/notificaciones";

export const useGestionarPostulacionesBeps = () => {
  const [allpostulaciones, setAllPostulaciones] = useState<any>([]);
  const [modal, setModal] = useState<boolean>(false);
  const [postulacion, setPostulacion] = useState<PostulacionBepsModel>(initialValuesPostulacionBepsModel);
  const [totalregistros, setTotalRegistros] = useState<number>(0);
  const [cantidadpáginas, setCantidadPáginas] = useState<number>(10);
  const [categorias, setCategorias] = useState<any>([]);
  const [filtros, setFiltros] = useState<filtrosPostulacionModel>(initialFiltrosPostulacionModel);
  const [allpostulacionessinfiltro, SetAllPostulacionesSinFiltro] = useState<any>([]);

  const cargarTodasPostulaciones = async (isBeps?: boolean) => {
    let { postulacionesBeps: postulaciones } = await apiParticipantes.consultarTodasPostulacionesBeps();
    //console.log(postulaciones, 'AQUII')
    setTotalRegistros(postulaciones.length);

 
    SetAllPostulacionesSinFiltro(postulaciones);
    return setAllPostulaciones(postulaciones);
  };
  const VerPropuesta = (datos: any) => {
    setPostulacion(datos);
    return setModal(true);
  };
  const AceptarModalPropuesta = async (observaciones?: any, countSubsanable?: any, setObservaciones?: any) => {
    if (countSubsanable > 0) {
      if (observaciones !== null && observaciones.length > 0) {
        await apiParticipantes.actualizarObservacion(postulacion.id_postulacion, observaciones);
        setObservaciones(null);
      } else {
        return ObjNotificaciones.MSG_ERROR('warning', '¡Ingresa las observaciones!', 'Debes indicar las observaciones cuando solicitas la subsanación de algún documento')
      }
    }

    await apiParticipantes.guardarDocumentosAdministrativosPostulacion(
      postulacion.id_postulacion,
      postulacion.documentos_administrativos
    );
    await apiParticipantes.guardarDocumentosTecnicosPostulacion(
      postulacion.id_postulacion,
      postulacion.documentos_tecnicos
    );
    let estado = "Aceptado";
    let documentosadminaceptar = [];
    let documentosadminrechazar = [];
    let documentosadminsubsanar = [];
    let documentostecnaceptar = [];
    if (postulacion.documentos_administrativos) {
      documentosadminaceptar = postulacion.documentos_administrativos.map((x: any) => x.checkaceptar);
      documentosadminrechazar = postulacion.documentos_administrativos.map((x: any) => x.checkcancelar);
      documentosadminsubsanar = postulacion.documentos_administrativos.map((x: any) => x.checksubsanable);
    }
    if (
      postulacion.documentos_tecnicos &&
      postulacion.documentos_tecnicos !== null &&
      Object.keys(postulacion.documentos_tecnicos).length !== 0
    ) {
      documentostecnaceptar = postulacion.documentos_tecnicos.map((x: any) => x.checkaceptartecnico);
    }
    //console.log(documentosadminaceptar, documentosadminrechazar, documentosadminsubsanar, documentostecnaceptar);
    let rechazada = documentosadminrechazar.filter((data: any) => data === true);
    let subsanar = documentosadminsubsanar.filter((data: any) => data === true);
    if (subsanar.length > 0) estado = "Subsanar";
    if (rechazada.length > 0) estado = "Rechazado";
    await apiParticipantes.cambiarEstadoPostulacion({ id_postulacion: postulacion.id_postulacion, estado: estado });
    let nuevoarray = allpostulaciones.map((data: any) => {
      if (data.id_postulacion === postulacion.id_postulacion) {
        return {
          ...data,
          estado: estado,
        };
      }
      return data;
    });
    openNotification({
      titulo: "Finalizado correctamente",
      descripcion: "Se han actualizado el estado de los documentos",
      placement: "bottomRight",
    });
    setAllPostulaciones(nuevoarray);
    return setModal(false);
  };
  // notification
  const openNotification = ({ titulo, descripcion, placement }: any) => {
    notification.info({
      message: titulo,
      description: descripcion,
      placement,
    });
  };
  const CancelarModal = () => {
    return setModal(false);
  };
  const descargarArchivo = async(url: string) => {
   try {
    let data: any = await DocumentosService.consultarArchivo(url);
    await fileDownload(data, url);
   } catch (error) {
     console.log(error)
   }
  };
  const cambiarCantidadPaginas = (e: any, value: any) => {
    setCantidadPáginas(value);
  };

  const obtenerCategoriasLineas = async () => {
    let data = await apiConvocatorias.getAllCategoriasLineaConvocatoria();
    return setCategorias(data.data);
  };

  const limpiarFiltros = async () => {
    let { postulacionesBeps: postulaciones } = await apiParticipantes.consultarTodasPostulacionesBeps();
    setTotalRegistros(postulaciones.length);
    setFiltros(initialFiltrosPostulacionModel);
    return setAllPostulaciones(allpostulacionessinfiltro);
  };

  const buscarpostulaciones = () => {
    let filtro: any = allpostulacionessinfiltro;
    if (filtros.buscarpalabra && filtros.buscarpalabra !== "") {
      filtro = filtro.filter((x: any) => {
        //console.log(x);
        if (x.nombre_participante !== null) {
          if (x.nombre_participante.toUpperCase().indexOf(filtros.buscarpalabra.trim().toUpperCase()) > -1) {
            return x;
          }
        }
      });
    }
    //console.log(filtros.estado)
    if (filtros.estado && filtros.estado !== "") {
      
      filtro = filtro.filter((x: any) => {
        if (x.estado === filtros.estado) {
          return x;
        }
      });
    }

    setTotalRegistros(filtro.length);
    return setAllPostulaciones(filtro);
  };
  return {
    allpostulaciones,
    setAllPostulaciones,
    cargarTodasPostulaciones,
    modal,
    VerPropuesta,
    AceptarModalPropuesta,
    CancelarModal,
    descargarArchivo,
    postulacion,
    totalregistros,
    cantidadpáginas,
    cambiarCantidadPaginas,
    categorias,
    obtenerCategoriasLineas,
    limpiarFiltros,
    buscarpostulaciones,
    setFiltros,
    filtros,
  };
};
